import type { ListTheme } from '../ListStyles.css';

import { listStyles, variants } from '../ListStyles.css';
import { baseTheme } from './ListBaseTheme.css';
import { multiVariantStyles } from './ListVariants.css';

export const ListStableTheme: ListTheme = {
  baseTheme,
  multiVariantStyles,
  variants,
  styles: listStyles
};
